import { assetCreditLabels } from './asset-credit-labels.js';
const en = {
    assetCredit: assetCreditLabels.en,
    yes: 'Yes',
    no: 'No',
    add: 'Add line',
    remove: 'Remove line',
    search: 'Search',
    templates: 'Journal templates',
    assets: 'Fixed assets',
    closing: 'Year closing',
    revaluations: 'Foreign currency valuation',
    hint: 'Review source evidence and proposals before posting. Dates, permissions and closed periods are checked again when saving.',
    name: 'Name',
    kind: 'Type',
    description: 'Description',
    reference: 'Reference',
    startDate: 'First proposal date',
    through: 'Through date',
    intervalMonths: 'Interval in months',
    reversalDate: 'Reversal date',
    amount: 'Amount',
    debitAccount: 'Debit account',
    creditAccount: 'Credit account',
    newTemplate: 'New template',
    newAsset: 'Register asset',
    save: 'Save',
    copy: 'Copy',
    edit: 'Edit',
    run: 'Create proposals',
    history: 'Version history',
    active: 'Active',
    version: 'Version',
    journal: 'Journal',
    propose: 'Propose depreciation',
    post: 'Post depreciation',
    dispose: 'Dispose asset',
    correct: 'Reverse event',
    acquiredOn: 'Acquisition date',
    inServiceOn: 'Depreciation starts / opening date',
    cost: 'Acquisition cost',
    residual: 'Residual value',
    openingDepreciation: 'Reviewed opening accumulated depreciation',
    OPENING: 'Carried depreciation',
    usefulLifeMonths: 'Useful life / remaining life (months)',
    assetAccount: 'Asset cost account',
    expenseAccount: 'Depreciation expense account',
    accumulatedAccount: 'Accumulated depreciation account',
    acquisitionJournal: 'Posted acquisition journal',
    openingEvidence: 'Reviewed opening evidence',
    lossAccount: 'Disposal expense account',
    proceedsInvoice: 'Posted sales invoice for proceeds (optional)',
    effectiveDate: 'Effective date',
    reason: 'Reason / evidence',
    year: 'Fiscal year',
    nextYear: 'Following fiscal year',
    equity: 'Equity carryforward account',
    preview: 'Review preview',
    confirmClose: 'Close fiscal year',
    reopen: 'Reopen fiscal year',
    rate: 'Home currency per foreign unit',
    rateDate: 'Rate date',
    rateSource: 'Rate source and evidence',
    shortTerm: 'Remaining term at most one year',
    fxAccount: 'Exchange gain or loss account',
    invoiceId: 'Financial invoice identity',
    confirmFx: 'Post valuation and reversal',
    cancel: 'Cancel',
    draft: 'Draft',
    posted: 'Posted',
    disposed: 'Disposed',
    empty: 'No records yet.',
    noChange: 'No valuation difference; no journal was posted.',
    saved: 'Saved',
    retry: 'Retry',
    validation: 'Please check the highlighted fields. Your entries have been retained.',
    profit: 'Profit / loss',
    closeRows: 'Closing entries',
    openRows: 'Opening balances',
    actions: 'Actions',
    details: 'Details',
    carryingAmount: 'Carrying amount',
    schedule: 'Depreciation schedule',
    depreciation: 'Depreciation',
    confirm: 'Confirm',
    navigation: 'Accounting workspaces',
    JOURNAL: 'Reusable journal',
    RECURRING: 'Recurring journal',
    ACCRUAL: 'Accrual',
    PROVISION: 'Provision',
    CLOSED: 'Closed',
    REOPENED: 'Reopened',
    DEPRECIATION: 'Depreciation',
    DISPOSAL: 'Disposal',
    CORRECTION: 'Correction',
    findings: {
        drafts: 'Unposted journals in this year',
        depreciation: 'Missing depreciation postings',
        priorYear: 'Earlier years remain open',
    },
    errors: {
        assetCreditProof: assetCreditLabels.en.errors.proof,
        assetCreditCapacity: assetCreditLabels.en.errors.capacity,
        assetCreditDependencies: assetCreditLabels.en.errors.dependencies,
        setup: 'Activate accounting first.',
        positive: 'Enter a positive amount.',
        date: 'Check the order of the dates.',
        residual: 'Residual value must be lower than cost.',
        accounts: 'Choose valid, active accounts of the required kind.',
        acquisition: 'The posted acquisition does not support this cost or was already assigned.',
        evidence: 'The source evidence is unavailable, reversed or already used.',
        inactive: 'This template is inactive.',
        range: 'Select at most 120 proposals per run.',
        disposed: 'This asset has been disposed or the event was reversed.',
        depreciationOrder: 'Post earlier depreciation first; correct later events before earlier ones.',
        years: 'Select consecutive, open fiscal years; reopen later closings first.',
        controls: 'Resolve the findings before closing.',
        reversalDate: 'Use the last day of an open period and the first day of the next open period.',
        maturity: 'The remaining term must match the invoice due date.',
        openItem: 'Only outstanding foreign currency items with a nonzero balance can be valued.',
        duplicate: 'This item already has a valuation for this date.',
        rateDate: 'The documented rate must be dated on the valuation date.',
    },
};
export const ledgerClosingLabels = {
    en,
    de: {
        assetCredit: assetCreditLabels.de,
        yes: 'Ja',
        no: 'Nein',
        add: 'Zeile hinzufügen',
        remove: 'Zeile entfernen',
        search: 'Suchen',
        templates: 'Buchungsvorlagen',
        assets: 'Anlagen',
        closing: 'Jahresabschluss',
        revaluations: 'Fremdwährungsbewertung',
        hint: 'Belege und Vorschläge vor der Buchung prüfen. Datum, Rechte und gesperrte Perioden werden beim Speichern erneut geprüft.',
        name: 'Name',
        kind: 'Art',
        description: 'Beschreibung',
        reference: 'Referenz',
        startDate: 'Erstes Vorschlagsdatum',
        through: 'Bis Datum',
        intervalMonths: 'Intervall in Monaten',
        reversalDate: 'Rückbuchungsdatum',
        amount: 'Betrag',
        debitAccount: 'Sollkonto',
        creditAccount: 'Habenkonto',
        newTemplate: 'Neue Vorlage',
        newAsset: 'Anlage erfassen',
        save: 'Speichern',
        copy: 'Kopieren',
        edit: 'Bearbeiten',
        run: 'Vorschläge erstellen',
        history: 'Versionsverlauf',
        active: 'Aktiv',
        version: 'Version',
        journal: 'Buchung',
        propose: 'Abschreibung vorschlagen',
        post: 'Abschreibung buchen',
        dispose: 'Anlage abgehen lassen',
        correct: 'Ereignis stornieren',
        acquiredOn: 'Anschaffungsdatum',
        inServiceOn: 'Abschreibungsbeginn / Eröffnungsdatum',
        cost: 'Anschaffungskosten',
        residual: 'Restwert',
        openingDepreciation: 'Geprüfte kumulierte Abschreibung bei Eröffnung',
        OPENING: 'Übernommene Abschreibung',
        usefulLifeMonths: 'Nutzungsdauer / Restnutzungsdauer (Monate)',
        assetAccount: 'Anschaffungskonto',
        expenseAccount: 'Abschreibungsaufwand',
        accumulatedAccount: 'Kumulierte Abschreibung',
        acquisitionJournal: 'Gebuchte Anschaffung',
        openingEvidence: 'Geprüfter Eröffnungsnachweis',
        lossAccount: 'Abgangsaufwand',
        proceedsInvoice: 'Gebuchte Ausgangsrechnung zum Erlös (optional)',
        effectiveDate: 'Wirksamkeitsdatum',
        reason: 'Grund / Nachweis',
        year: 'Geschäftsjahr',
        nextYear: 'Folgendes Geschäftsjahr',
        equity: 'Eigenkapitalkonto für Vortrag',
        preview: 'Vorschau prüfen',
        confirmClose: 'Geschäftsjahr abschließen',
        reopen: 'Geschäftsjahr wieder öffnen',
        rate: 'Hauswährung je Fremdwährungseinheit',
        rateDate: 'Kursdatum',
        rateSource: 'Kursquelle und Nachweis',
        shortTerm: 'Restlaufzeit höchstens ein Jahr',
        fxAccount: 'Kursgewinn- oder Kursverlustkonto',
        invoiceId: 'Finanzielle Rechnungszuordnung',
        confirmFx: 'Bewertung und Rückbuchung buchen',
        cancel: 'Abbrechen',
        draft: 'Entwurf',
        posted: 'Gebucht',
        disposed: 'Abgegangen',
        empty: 'Noch keine Einträge.',
        noChange: 'Kein Bewertungsunterschied; es wurde keine Buchung erzeugt.',
        saved: 'Gespeichert',
        retry: 'Erneut versuchen',
        validation: 'Bitte markierte Felder prüfen. Ihre Eingaben bleiben erhalten.',
        profit: 'Gewinn / Verlust',
        closeRows: 'Abschlussbuchungen',
        openRows: 'Eröffnungsbestände',
        actions: 'Aktionen',
        details: 'Details',
        carryingAmount: 'Buchwert',
        schedule: 'Abschreibungsplan',
        depreciation: 'Abschreibung',
        confirm: 'Bestätigen',
        navigation: 'Bereiche der Buchhaltung',
        JOURNAL: 'Wiederverwendbare Buchung',
        RECURRING: 'Wiederkehrende Buchung',
        ACCRUAL: 'Abgrenzung',
        PROVISION: 'Rückstellung',
        CLOSED: 'Abgeschlossen',
        REOPENED: 'Wieder geöffnet',
        DEPRECIATION: 'Abschreibung',
        DISPOSAL: 'Abgang',
        CORRECTION: 'Korrektur',
        findings: {
            drafts: 'Nicht gebuchte Entwürfe im Jahr',
            depreciation: 'Fehlende Abschreibungsbuchungen',
            priorYear: 'Frühere Jahre sind noch offen',
        },
        errors: {
            assetCreditProof: assetCreditLabels.de.errors.proof,
            assetCreditCapacity: assetCreditLabels.de.errors.capacity,
            assetCreditDependencies: assetCreditLabels.de.errors.dependencies,
            setup: 'Zuerst Buchhaltung aktivieren.',
            positive: 'Einen positiven Betrag eingeben.',
            date: 'Reihenfolge der Daten prüfen.',
            residual: 'Der Restwert muss unter den Anschaffungskosten liegen.',
            accounts: 'Gültige aktive Konten der benötigten Art wählen.',
            acquisition: 'Die gebuchte Anschaffung deckt die Kosten nicht oder ist bereits zugeordnet.',
            evidence: 'Der Nachweis ist nicht verfügbar, storniert oder bereits verwendet.',
            inactive: 'Diese Vorlage ist inaktiv.',
            range: 'Höchstens 120 Vorschläge je Lauf wählen.',
            disposed: 'Die Anlage ist abgegangen oder das Ereignis wurde storniert.',
            depreciationOrder: 'Frühere Abschreibungen zuerst buchen; spätere Ereignisse zuerst korrigieren.',
            years: 'Aufeinanderfolgende offene Jahre wählen; spätere Abschlüsse zuerst öffnen.',
            controls: 'Prüffeststellungen vor dem Abschluss klären.',
            reversalDate: 'Letzten Tag einer offenen Periode und ersten Tag der folgenden offenen Periode verwenden.',
            maturity: 'Die Restlaufzeit muss zum Fälligkeitsdatum passen.',
            openItem: 'Nur offene Fremdwährungsposten mit einem Saldo ungleich null können bewertet werden.',
            duplicate: 'Für diesen Posten und Stichtag besteht bereits eine Bewertung.',
            rateDate: 'Der nachgewiesene Kurs muss vom Bewertungsstichtag stammen.',
        },
    },
    es: {
        assetCredit: assetCreditLabels.es,
        yes: 'Sí',
        no: 'No',
        add: 'Añadir línea',
        remove: 'Eliminar línea',
        search: 'Buscar',
        templates: 'Plantillas contables',
        assets: 'Activos fijos',
        closing: 'Cierre anual',
        revaluations: 'Valoración de divisas',
        hint: 'Revise documentos y propuestas antes de contabilizar. Al guardar se comprueban fechas, permisos y períodos cerrados.',
        name: 'Nombre',
        kind: 'Tipo',
        description: 'Descripción',
        reference: 'Referencia',
        startDate: 'Primera propuesta',
        through: 'Hasta',
        intervalMonths: 'Intervalo en meses',
        reversalDate: 'Fecha de reversión',
        amount: 'Importe',
        debitAccount: 'Cuenta de debe',
        creditAccount: 'Cuenta de haber',
        newTemplate: 'Nueva plantilla',
        newAsset: 'Registrar activo',
        save: 'Guardar',
        copy: 'Copiar',
        edit: 'Editar',
        run: 'Crear propuestas',
        history: 'Historial de versiones',
        active: 'Activa',
        version: 'Versión',
        journal: 'Asiento',
        propose: 'Proponer amortización',
        post: 'Contabilizar amortización',
        dispose: 'Dar de baja',
        correct: 'Revertir evento',
        acquiredOn: 'Fecha de adquisición',
        inServiceOn: 'Inicio de amortización / apertura',
        cost: 'Coste de adquisición',
        residual: 'Valor residual',
        openingDepreciation: 'Amortización acumulada de apertura revisada',
        OPENING: 'Amortización heredada',
        usefulLifeMonths: 'Vida útil / restante (meses)',
        assetAccount: 'Cuenta de coste del activo',
        expenseAccount: 'Cuenta de gasto de amortización',
        accumulatedAccount: 'Amortización acumulada',
        acquisitionJournal: 'Asiento de adquisición contabilizado',
        openingEvidence: 'Justificante de apertura revisado',
        lossAccount: 'Cuenta de gasto de baja',
        proceedsInvoice: 'Factura de venta contabilizada (opcional)',
        effectiveDate: 'Fecha efectiva',
        reason: 'Motivo / justificante',
        year: 'Ejercicio',
        nextYear: 'Ejercicio siguiente',
        equity: 'Cuenta de patrimonio para arrastre',
        preview: 'Revisar vista previa',
        confirmClose: 'Cerrar ejercicio',
        reopen: 'Reabrir ejercicio',
        rate: 'Moneda base por unidad extranjera',
        rateDate: 'Fecha del tipo',
        rateSource: 'Fuente y justificante del tipo',
        shortTerm: 'Plazo restante de un año como máximo',
        fxAccount: 'Cuenta de ganancia o pérdida de cambio',
        invoiceId: 'Identidad contable de factura',
        confirmFx: 'Contabilizar valoración y reversión',
        cancel: 'Cancelar',
        draft: 'Borrador',
        posted: 'Contabilizado',
        disposed: 'Dado de baja',
        empty: 'No hay registros.',
        noChange: 'Sin diferencia de valoración; no se creó ningún asiento.',
        saved: 'Guardado',
        retry: 'Reintentar',
        validation: 'Revise los campos marcados. Sus datos se conservan.',
        profit: 'Beneficio / pérdida',
        closeRows: 'Asientos de cierre',
        openRows: 'Saldos de apertura',
        actions: 'Acciones',
        details: 'Detalles',
        carryingAmount: 'Valor contable',
        schedule: 'Plan de amortización',
        depreciation: 'Amortización',
        confirm: 'Confirmar',
        navigation: 'Áreas contables',
        JOURNAL: 'Asiento reutilizable',
        RECURRING: 'Asiento periódico',
        ACCRUAL: 'Periodificación',
        PROVISION: 'Provisión',
        CLOSED: 'Cerrado',
        REOPENED: 'Reabierto',
        DEPRECIATION: 'Amortización',
        DISPOSAL: 'Baja',
        CORRECTION: 'Corrección',
        findings: {
            drafts: 'Borradores sin contabilizar en el ejercicio',
            depreciation: 'Amortizaciones pendientes',
            priorYear: 'Hay ejercicios anteriores abiertos',
        },
        errors: {
            assetCreditProof: assetCreditLabels.es.errors.proof,
            assetCreditCapacity: assetCreditLabels.es.errors.capacity,
            assetCreditDependencies: assetCreditLabels.es.errors.dependencies,
            setup: 'Active primero la contabilidad.',
            positive: 'Introduzca un importe positivo.',
            date: 'Compruebe el orden de las fechas.',
            residual: 'El valor residual debe ser inferior al coste.',
            accounts: 'Seleccione cuentas activas válidas del tipo requerido.',
            acquisition: 'El asiento de adquisición no justifica el coste o ya está asignado.',
            evidence: 'El justificante no está disponible, está revertido o ya se utilizó.',
            inactive: 'La plantilla está inactiva.',
            range: 'Seleccione un máximo de 120 propuestas por ejecución.',
            disposed: 'El activo está dado de baja o el evento está revertido.',
            depreciationOrder: 'Contabilice antes las amortizaciones anteriores y corrija primero los eventos posteriores.',
            years: 'Seleccione ejercicios abiertos consecutivos y reabra antes los cierres posteriores.',
            controls: 'Resuelva los hallazgos antes del cierre.',
            reversalDate: 'Use el último día de un período abierto y el primero del siguiente.',
            maturity: 'El plazo restante debe coincidir con el vencimiento de la factura.',
            openItem: 'Solo se valoran partidas pendientes en divisa con saldo distinto de cero.',
            duplicate: 'Ya existe una valoración para esta partida y fecha.',
            rateDate: 'El tipo documentado debe corresponder a la fecha de valoración.',
        },
    },
    fr: {
        assetCredit: assetCreditLabels.fr,
        yes: 'Oui',
        no: 'Non',
        add: 'Ajouter une ligne',
        remove: 'Supprimer la ligne',
        search: 'Rechercher',
        templates: 'Modèles comptables',
        assets: 'Immobilisations',
        closing: 'Clôture annuelle',
        revaluations: 'Évaluation des devises',
        hint: 'Vérifiez les justificatifs et propositions avant comptabilisation. Les dates, droits et périodes clôturées sont contrôlés à nouveau lors de l’enregistrement.',
        name: 'Nom',
        kind: 'Type',
        description: 'Description',
        reference: 'Référence',
        startDate: 'Première proposition',
        through: 'Jusqu’au',
        intervalMonths: 'Intervalle en mois',
        reversalDate: 'Date d’extourne',
        amount: 'Montant',
        debitAccount: 'Compte au débit',
        creditAccount: 'Compte au crédit',
        newTemplate: 'Nouveau modèle',
        newAsset: 'Enregistrer une immobilisation',
        save: 'Enregistrer',
        copy: 'Copier',
        edit: 'Modifier',
        run: 'Créer les propositions',
        history: 'Historique des versions',
        active: 'Actif',
        version: 'Version',
        journal: 'Écriture',
        propose: 'Proposer l’amortissement',
        post: 'Comptabiliser l’amortissement',
        dispose: 'Sortir l’immobilisation',
        correct: 'Extourner l’événement',
        acquiredOn: 'Date d’acquisition',
        inServiceOn: 'Début d’amortissement / ouverture',
        cost: 'Coût d’acquisition',
        residual: 'Valeur résiduelle',
        openingDepreciation: 'Amortissement cumulé d’ouverture vérifié',
        OPENING: 'Amortissement repris',
        usefulLifeMonths: 'Durée utile / restante (mois)',
        assetAccount: 'Compte de coût de l’immobilisation',
        expenseAccount: 'Compte de charge d’amortissement',
        accumulatedAccount: 'Amortissement cumulé',
        acquisitionJournal: 'Écriture d’acquisition comptabilisée',
        openingEvidence: 'Justificatif d’ouverture vérifié',
        lossAccount: 'Compte de charge de sortie',
        proceedsInvoice: 'Facture de vente comptabilisée (facultatif)',
        effectiveDate: 'Date d’effet',
        reason: 'Motif / justificatif',
        year: 'Exercice',
        nextYear: 'Exercice suivant',
        equity: 'Compte de capitaux propres de report',
        preview: 'Vérifier l’aperçu',
        confirmClose: 'Clôturer l’exercice',
        reopen: 'Rouvrir l’exercice',
        rate: 'Monnaie de base par unité étrangère',
        rateDate: 'Date du cours',
        rateSource: 'Source et justificatif du cours',
        shortTerm: 'Durée résiduelle d’un an au maximum',
        fxAccount: 'Compte de gain ou perte de change',
        invoiceId: 'Identité comptable de la facture',
        confirmFx: 'Comptabiliser évaluation et extourne',
        cancel: 'Annuler',
        draft: 'Brouillon',
        posted: 'Comptabilisé',
        disposed: 'Sorti',
        empty: 'Aucun enregistrement.',
        noChange: 'Aucun écart d’évaluation ; aucune écriture créée.',
        saved: 'Enregistré',
        retry: 'Réessayer',
        validation: 'Vérifiez les champs indiqués. Vos saisies sont conservées.',
        profit: 'Bénéfice / perte',
        closeRows: 'Écritures de clôture',
        openRows: 'Soldes d’ouverture',
        actions: 'Actions',
        details: 'Détails',
        carryingAmount: 'Valeur comptable',
        schedule: 'Plan d’amortissement',
        depreciation: 'Amortissement',
        confirm: 'Confirmer',
        navigation: 'Espaces comptables',
        JOURNAL: 'Écriture réutilisable',
        RECURRING: 'Écriture périodique',
        ACCRUAL: 'Régularisation',
        PROVISION: 'Provision',
        CLOSED: 'Clôturé',
        REOPENED: 'Rouvert',
        DEPRECIATION: 'Amortissement',
        DISPOSAL: 'Sortie',
        CORRECTION: 'Correction',
        findings: {
            drafts: 'Brouillons non comptabilisés de l’exercice',
            depreciation: 'Amortissements manquants',
            priorYear: 'Des exercices précédents restent ouverts',
        },
        errors: {
            assetCreditProof: assetCreditLabels.fr.errors.proof,
            assetCreditCapacity: assetCreditLabels.fr.errors.capacity,
            assetCreditDependencies: assetCreditLabels.fr.errors.dependencies,
            setup: 'Activez d’abord la comptabilité.',
            positive: 'Saisissez un montant positif.',
            date: 'Vérifiez l’ordre des dates.',
            residual: 'La valeur résiduelle doit être inférieure au coût.',
            accounts: 'Choisissez des comptes actifs valides du type requis.',
            acquisition: 'L’écriture d’acquisition ne justifie pas ce coût ou est déjà affectée.',
            evidence: 'Le justificatif est indisponible, extourné ou déjà utilisé.',
            inactive: 'Ce modèle est inactif.',
            range: 'Sélectionnez au maximum 120 propositions par exécution.',
            disposed: 'L’immobilisation est sortie ou l’événement a été extourné.',
            depreciationOrder: 'Comptabilisez les amortissements antérieurs ; corrigez d’abord les événements ultérieurs.',
            years: 'Choisissez des exercices ouverts consécutifs et rouvrez d’abord les clôtures ultérieures.',
            controls: 'Résolvez les constats avant la clôture.',
            reversalDate: 'Utilisez le dernier jour d’une période ouverte et le premier de la suivante.',
            maturity: 'La durée résiduelle doit correspondre à l’échéance de la facture.',
            openItem: 'Seuls les postes ouverts en devise à solde non nul peuvent être évalués.',
            duplicate: 'Ce poste possède déjà une évaluation à cette date.',
            rateDate: 'Le cours justifié doit dater du jour de l’évaluation.',
        },
    },
    tr: {
        assetCredit: assetCreditLabels.tr,
        yes: 'Evet',
        no: 'Hayır',
        add: 'Satır ekle',
        remove: 'Satırı kaldır',
        search: 'Ara',
        templates: 'Muhasebe şablonları',
        assets: 'Duran varlıklar',
        closing: 'Yıl kapanışı',
        revaluations: 'Döviz değerlemesi',
        hint: 'Kaydetmeden önce belgeleri ve önerileri inceleyin. Tarihler, yetkiler ve kapalı dönemler kayıt sırasında yeniden denetlenir.',
        name: 'Ad',
        kind: 'Tür',
        description: 'Açıklama',
        reference: 'Referans',
        startDate: 'İlk öneri tarihi',
        through: 'Bitiş tarihi',
        intervalMonths: 'Ay cinsinden aralık',
        reversalDate: 'Ters kayıt tarihi',
        amount: 'Tutar',
        debitAccount: 'Borç hesabı',
        creditAccount: 'Alacak hesabı',
        newTemplate: 'Yeni şablon',
        newAsset: 'Varlık kaydet',
        save: 'Kaydet',
        copy: 'Kopyala',
        edit: 'Düzenle',
        run: 'Önerileri oluştur',
        history: 'Sürüm geçmişi',
        active: 'Etkin',
        version: 'Sürüm',
        journal: 'Muhasebe kaydı',
        propose: 'Amortisman öner',
        post: 'Amortismanı muhasebeleştir',
        dispose: 'Varlığı elden çıkar',
        correct: 'Olayı ters kaydet',
        acquiredOn: 'Edinim tarihi',
        inServiceOn: 'Amortisman başlangıcı / açılış tarihi',
        cost: 'Edinim maliyeti',
        residual: 'Kalıntı değer',
        openingDepreciation: 'İncelenmiş açılış birikmiş amortismanı',
        OPENING: 'Devralınan amortisman',
        usefulLifeMonths: 'Faydalı / kalan ömür (ay)',
        assetAccount: 'Varlık maliyet hesabı',
        expenseAccount: 'Amortisman gider hesabı',
        accumulatedAccount: 'Birikmiş amortisman hesabı',
        acquisitionJournal: 'Muhasebeleştirilmiş edinim kaydı',
        openingEvidence: 'İncelenmiş açılış kanıtı',
        lossAccount: 'Elden çıkarma gider hesabı',
        proceedsInvoice: 'Muhasebeleştirilmiş satış faturası (isteğe bağlı)',
        effectiveDate: 'Geçerlilik tarihi',
        reason: 'Gerekçe / kanıt',
        year: 'Mali yıl',
        nextYear: 'Sonraki mali yıl',
        equity: 'Özkaynak devir hesabı',
        preview: 'Önizlemeyi incele',
        confirmClose: 'Mali yılı kapat',
        reopen: 'Mali yılı yeniden aç',
        rate: 'Yabancı para birimi başına ana para birimi',
        rateDate: 'Kur tarihi',
        rateSource: 'Kur kaynağı ve kanıtı',
        shortTerm: 'Kalan vade en fazla bir yıl',
        fxAccount: 'Kur kârı veya zararı hesabı',
        invoiceId: 'Finansal fatura kimliği',
        confirmFx: 'Değerleme ve ters kaydı muhasebeleştir',
        cancel: 'İptal',
        draft: 'Taslak',
        posted: 'Muhasebeleştirildi',
        disposed: 'Elden çıkarıldı',
        empty: 'Henüz kayıt yok.',
        noChange: 'Değerleme farkı yok; muhasebe kaydı oluşturulmadı.',
        saved: 'Kaydedildi',
        retry: 'Yeniden dene',
        validation: 'İşaretli alanları kontrol edin. Girdileriniz korunmuştur.',
        profit: 'Kâr / zarar',
        closeRows: 'Kapanış kayıtları',
        openRows: 'Açılış bakiyeleri',
        actions: 'İşlemler',
        details: 'Ayrıntılar',
        carryingAmount: 'Defter değeri',
        schedule: 'Amortisman planı',
        depreciation: 'Amortisman',
        confirm: 'Onayla',
        navigation: 'Muhasebe çalışma alanları',
        JOURNAL: 'Yeniden kullanılabilir kayıt',
        RECURRING: 'Dönemsel kayıt',
        ACCRUAL: 'Dönem ayırımı',
        PROVISION: 'Karşılık',
        CLOSED: 'Kapalı',
        REOPENED: 'Yeniden açıldı',
        DEPRECIATION: 'Amortisman',
        DISPOSAL: 'Elden çıkarma',
        CORRECTION: 'Düzeltme',
        findings: {
            drafts: 'Bu yılda muhasebeleştirilmemiş taslaklar',
            depreciation: 'Eksik amortisman kayıtları',
            priorYear: 'Önceki yıllar açık',
        },
        errors: {
            assetCreditProof: assetCreditLabels.tr.errors.proof,
            assetCreditCapacity: assetCreditLabels.tr.errors.capacity,
            assetCreditDependencies: assetCreditLabels.tr.errors.dependencies,
            setup: 'Önce muhasebeyi etkinleştirin.',
            positive: 'Pozitif bir tutar girin.',
            date: 'Tarih sırasını kontrol edin.',
            residual: 'Kalıntı değer maliyetten düşük olmalıdır.',
            accounts: 'Gerekli türde geçerli ve etkin hesaplar seçin.',
            acquisition: 'Edinim kaydı bu maliyeti desteklemiyor veya önceden atanmış.',
            evidence: 'Kaynak kanıtı kullanılamıyor, ters kaydedilmiş veya kullanılmış.',
            inactive: 'Bu şablon etkin değil.',
            range: 'Her çalıştırmada en fazla 120 öneri seçin.',
            disposed: 'Varlık elden çıkarılmış veya olay ters kaydedilmiş.',
            depreciationOrder: 'Önce önceki amortismanları kaydedin; düzeltmede sonraki olaylardan başlayın.',
            years: 'Ardışık açık mali yıllar seçin; önce sonraki kapanışları yeniden açın.',
            controls: 'Kapatmadan önce bulguları giderin.',
            reversalDate: 'Açık dönemin son gününü ve sonraki açık dönemin ilk gününü kullanın.',
            maturity: 'Kalan vade fatura vade tarihiyle eşleşmelidir.',
            openItem: 'Yalnızca bakiyesi sıfır olmayan açık döviz kalemleri değerlenebilir.',
            duplicate: 'Bu kalem ve tarih için değerleme zaten var.',
            rateDate: 'Kanıtlanan kur değerleme tarihine ait olmalıdır.',
        },
    },
};
//# sourceMappingURL=ledger-closing.js.map